import { gql } from '@apollo/client';
import ACADEMIC_SESSION_FRAGMENT from 'graph/fragments/academic-session';

const GET_ACADEMIC_SESSIONS = gql`
  query getAcademicSessions($where: AcademicSessionsWhereInput, $organizationId: Int!) {
    academicSessions(where: $where) {
      ...BaseAcademicSession
      active
      default
    }
    organizationSetting(
      where: { appId: null, organizationId: $organizationId, setting: "upcomingAcademicSession" }
    ) {
      id
      organizationId
      setting
      value
    }
  }
  ${ACADEMIC_SESSION_FRAGMENT}
`;

export default GET_ACADEMIC_SESSIONS;
